// import GraficaAvances from
// '@/components/administracion/ejecucion/estimaciones/reportes/GraficaAvanceEstimaciones.vue';
import mixGenerarPdf from '@/helpers/mixGenerarPdf';
import mixFormatoEstructura from '@/helpers/mixFormatoEstructura';
import mixGraficaAvanceEstimaciones from '@/components/administracion/ejecucion/estimaciones/reportes/mixGraficaAvanceEstimaciones';

export default {
  name: 'MainGraficaAvancesEstimaciones',
  /*
  props: {
    estimacion: {
      type: Object,
      required: true,
    },
    contratoEstimaciones: {
      type: Array,
      required: true,
    },
    contrato: {
      type: Object,
      required: true,
    },
    programasobra: {
      type: Array,
      required: true,
    },
    firmas: {
      type: Array,
      required: false,
    },
  },
  */
  data() {
    return {
      activarMostrarGrafica: false,
    };
  },
  components: {
    // GraficaAvances,
  },
  mixins: [mixGenerarPdf, mixFormatoEstructura, mixGraficaAvanceEstimaciones],
  methods: {
    mostrarGrafica() {
      this.activarMostrarGrafica = true;
      this.$emit('mostrarGrafica');
    },
    formatoObjeto(objeto) {
      return this.formatoEstructura(objeto);
    },
    async generarPdfGraficaAvance() {
      this.$emit('generando');
      const grafica = this.mixCalcularPuntosGrafica;
      const graficaConFormato = {
        programado: grafica.programado.map((p) => `$${p.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`),
        financiero: grafica.financiero.map((p) => `$${p.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`),
        programadoP: grafica.programadoPorcentaje.map((p) => `${p}%`),
        financieroP: grafica.financieroPorcentaje.map((p) => `${p}%`),
        numeroMeses: grafica.programado.length,
      };
      const contratoConFormato = this.formatoObjeto(this.contrato);
      const estimacionConFormato = this.formatoObjeto(this.estimacion);
      const datos = {
        supervisionExterna: this.getContratoSupervisionExterna?.contratoRelacionado
          ?.contratista?.nombreRazonSocial || '',
      };
      const supervisor = this.getSupervisor || '';
      const firmasFuncionarios = this.firmas;
      const cliente = this.getCliente || { logo: '', nombre: '' };

      let nombreTemplate = 'templateGraficaAvanceEstimacion';
      if (this.contrato.esObraFinanciada) { nombreTemplate = 'templateGraficaAvanceEstimacion'; }
      graficaConFormato.financiero[0] = '-';
      graficaConFormato.financieroP[0] = '-';

      await this.mixGenerarPdf({
        configuracion: {
          path: 'wepp/wep',
          PUPPETEER_CONFIGURACION: {
            landscape: true,
            format: 'A3',
          },
          nombreTemplate,
        },
        data: {
          grafica,
          graficaConFormato,
          contrato: contratoConFormato,
          estimacion: estimacionConFormato,
          supervisor,
          firmas: firmasFuncionarios,
          datos,
          cliente,
          footer: '',
        },
      }, `${this.contrato.numero}_GraficaAvanceEstimacion_${this.estimacion.numero}`);
      this.generandoPdfGraficaAvanceEstimaciones = false;
      this.$emit('terminando');
    },

  },
  computed: {
    getSupervisor() {
      if (!this.contrato) return null;
      if (!this.contrato.responsables) return null;
      return this.contrato.responsables.find((responsable) => responsable.principal === true);
    },
    getContratoSupervisionExterna() {
      if (this.contrato.contratosRelacionados.length <= 0) return null;
      return this.contrato.contratosRelacionados
        .find(({ esSupervisionExterna }) => esSupervisionExterna === true);
    },
    getCliente() {
      if (!this.contrato.cliente) return { logo: '', nombre: '' };
      return this.contrato.cliente;
    },
  },
};
